import { render, staticRenderFns } from "./UpdateAddressDialog.vue?vue&type=template&id=262fc2f8&"
import script from "./UpdateAddressDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports